import React from 'react';
import t from 'react-translate';

// redux
import { useSelector } from 'react-redux';
import { SyncingStatus } from 'redux/schemas/models/lecture-page';
import { getCurrentCourse, getFlatCourseAliases } from 'redux/selectors/course';

// hooks
import { useLecturePageFromParams, useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { useDeleteLecture, useHideAddUIOnOpen } from 'lecture_pages/hooks/lecture-page-edit-top-panel';

// components
import TopPanelActionButton from './top-panel-action-button';
import { config } from '../../../../../config/config.json';

const DeleteLessonButton = () => {
  const params = useLecturePageParams();
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));
  const currentCourse = useSelector(getCurrentCourse);
  const lecturePage = useLecturePageFromParams();
  const deleteThisLecture = useDeleteLecture();
  const hideAddUIOnOpen = useHideAddUIOnOpen();

  const handleDelete = () => {
    hideAddUIOnOpen();
    deleteThisLecture();
  };

  const disableDelete = currentCourse?.isContentManagementCollection
    && (lecturePage?.contentManagementLinks?.length > 0
      || lecturePage?.syncingStatus === SyncingStatus.SYNC_IN_PROGRESS);

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='trash'
        tooltipText={disableDelete
          ? t.LECTURE_PAGES.ADMIN.COG_OPTIONS.DELETE_TOOLTIP()
          : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DELETE_LESSON(courseAliases)}
        iconClassName='text-danger'
        onClick={handleDelete}
        disabled={disableDelete}
        ariaLabel={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.DELETE_LESSON(courseAliases)}
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.deleteLessonOption}
      />
    </React.Fragment>
  );
};

export default DeleteLessonButton;
